import { Component, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { UserManagementService } from '../../services/user-management.service';
import { AuditService } from '../../services/audit.service';
import { AuditLogViewModel } from '../../models/audit-log-view-model';
import { TerminalViewModel } from '../../models/terminal-view-model';
import { LoggedInUser } from '../../models/user';
import { UserViewModel } from '../../models/user-view-model';
import { MerchantService } from '../../services/merchant.service';
import { TerminalService } from '../../services/terminal.service';

@Component({
  selector: 'dashboard-default-component',
  templateUrl: './dashboard-default.component.html',
  styleUrls: ['./dashboard-default.component.scss']
})
export class DashboardDefaultComponent implements OnInit {
  public currentDashboard: string = 'default'; 
  private subscription: Subscription;
  public terminals: TerminalViewModel[] = [];
  public participantLogins: { user: string, date: Date }[] = [];
  public currentUser: Observable<LoggedInUser>;
  public isAggregator: boolean;
  public data: string;
  public getLastUserInteraction: AuditLogViewModel;

  public get activeTerminal(): number { return this._terminalService.countActive; }
  public get inactiveTerminal(): number { return this._terminalService.countInactive; }
  public get totalTerminals(): number { return this._terminalService.count; }
  public get merchantCount(): number { return this._merchantService.count; }
  constructor(
    private _userDataStore: UserDataStoreService,
    private _userManagementService: UserManagementService,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _merchantService: MerchantService,
    private _auditService: AuditService
  ) {
    this.subscription = this._userDataStore.selectedParticipantObservable.subscribe(async () => {
      await this.init();
    });
  }

  ngOnInit() { }

  private async init(): Promise<void> {
    this._ngxUiLoaderService.start();
    await this.initParticipantLogins();

    this.currentUser = await this._userDataStore.currentUser;
    if (this.currentUser?.source['value']) {
      this.getLastUserInteraction = await this._auditService.GetLastUserInteraction(this.currentUser.source['value'].id);
      this.data = this.getLastUserInteraction?.details;
    }
    this._ngxUiLoaderService.stop();
  }

  private async initParticipantLogins(): Promise<void> {
    const users: UserViewModel[] = await this._userManagementService.GetParticipantUsersByActivity(2, 0);
    this.participantLogins = users.map(u => ({ user: u.email, date: u.lastLogin }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
